<!-- eslint-disable camelcase -->
<template>
  <d-container fluid>
    <d-form @submit.prevent="save()" :validated="hasErrors">
      <d-row>
        <d-col sm="12">
          <d-card>
            <div class="d-flex justify-content-between align-items-center p-3">
              <h3 class="table-title m-0">Templates de Extração de PDF</h3>
              <d-button type="button" class="btn-success" @click="addTemplate()">+ Novo Modelo de PDF</d-button>
            </div>

            <d-tabs class="custom-tabs" ref="tabs" v-model="activeTab">
              <d-tab :title="template.label || 'Novo'" class="p-4" v-for="(template, tIndex) in model" :key="tIndex">

                <d-form-row class="mb-4 pb-3 border-bottom">
                  <d-col md="6" class="form-group">
                    <label>Nome do Modelo</label>
                    <d-form-input type="text" placeholder="Ex: Histograma Calor - Lab X" v-model="template.label" />
                  </d-col>
                  <d-col md="4" class="form-group">
                    <label>Chave de Identificação</label>
                    <d-form-input :state="hasErrorField(tIndex + '.type')" type="text" placeholder="Ex: sample_heat" v-model="template.type" @input="formatTypeKey(tIndex)" />
                    <d-form-invalid-feedback>Chave de Identificação é obrigatório</d-form-invalid-feedback>
                  </d-col>
                  <d-col md="2" class="form-group d-flex align-items-end">
                    <d-button type="button" class="btn-danger w-100 mb-1" @click="confirmRemoveTemplate(tIndex)">
                      Excluir Modelo
                    </d-button>
                  </d-col>
                </d-form-row>

                <h5 class="text-uppercase text-muted mb-3">Tabelas do Modelo</h5>
                <div v-for="(table, index) in template.tables" :key="'table_'+index" class="mb-4">
                  <d-card class="card-small shadow-sm">
                    <d-card-header class="border-bottom bg-light">
                      <d-row class="align-items-center">
                        <d-col><h6 class="m-0 text-primary font-weight-bold">Configuração da Tabela {{ index + 1 }}</h6></d-col>
                        <d-col class="text-right">
                           <span class="ml-auto text-right text-semibold col-auto px-0">
                              <i class="fas fa-plus" @click.stop="addTable(tIndex)" v-if="index + 1 === template.tables.length" />
                              <i class="fas fa-minus" @click.stop="confirmRemoveTable(tIndex, index)" v-if="template.tables.length > 1" />
                            </span>
                        </d-col>
                      </d-row>
                    </d-card-header>

                    <d-list-group flush>
                      <d-list-group-item class="p-3">
                        <d-row class="mb-3">
                          <d-col md="6">
                            <label class="small font-weight-bold">Início</label>
                            <d-form-input v-model="table.trigger" placeholder="Ex: Resumo por evento:" />
                          </d-col>
                          <d-col md="6">
                            <label class="small font-weight-bold">Parar em</label>
                            <d-form-input :value="table.stop_at ? table.stop_at[0] : ''" @input="val => $set(table.stop_at, 0, val)" placeholder="Ex: Resumo e resultado..." />
                          </d-col>
                        </d-row>
                        <d-row class="mb-3">
                          <d-col md="12">
                            <label class="small font-weight-bold">Headers</label>
                            <div class="border rounded p-2 bg-white min-h-tags">
                              <ul class="options">
                                <li v-for="(head, hIdx) in table.headers" :key="hIdx">
                                  <span class="label delete" @click="table.headers.splice(hIdx, 1)"><i class="material-icons">delete</i></span>
                                  <span class="label">{{ head }}</span>
                                </li>
                                <li class="add-new-tag">
                                  <input type="text" placeholder="+ Novo header (Enter)" @keydown.enter.prevent.stop="addHeader($event, tIndex, index)" />
                                </li>
                              </ul>
                            </div>
                          </d-col>
                        </d-row>
                        <d-row>
                          <d-col md="12">
                            <label class="small font-weight-bold">Ignorar</label>
                            <div class="border rounded p-2 bg-white min-h-tags">
                              <ul class="options">
                                <li v-for="(ign, iIdx) in table.ignore" :key="iIdx" class="bg-grey-tag">
                                  <span class="label delete" @click="table.ignore.splice(iIdx, 1)"><i class="material-icons">delete</i></span>
                                  <span class="label">{{ ign }}</span>
                                </li>
                                <li class="add-new-tag">
                                  <input type="text" placeholder="+ Ignorar dado (Enter)" @keydown.enter.prevent.stop="addIgnore($event, tIndex, index)" />
                                </li>
                              </ul>
                            </div>
                          </d-col>
                        </d-row>
                      </d-list-group-item>
                    </d-list-group>
                  </d-card>
                </div>

                <div class="mt-4 p-3 bg-light rounded border border-info">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 class="text-info m-0 font-weight-bold"><i class="fas fa-flask mr-2"></i>Testar Extração e Mapear</h6>
                      <small class="text-muted">Insira um PDF real para testar as regras acima e ligar os dados ao sistema.</small>
                    </div>

                    <input type="file" :ref="'fileInput_'+tIndex" class="d-none" @change="uploadTestPdf($event, tIndex)" accept=".pdf">
                    <d-button type="button" class="btn-info" @click="$refs['fileInput_'+tIndex][0].click()" :disabled="testingPdf">
                      {{ testingPdf ? 'Processando...' : 'Carregar PDF de Teste' }}
                    </d-button>
                  </div>
                </div>

                <pdf-mapper
                  v-if="template.pdf_test_data"
                  :pdf-data="template.pdf_test_data"
                  :template-type="getRiskTypeFromTemplate(template.type)"
                  :mapping="template.mapping"
                  @update-mapping="novoMapping => $set(model[tIndex], 'mapping', novoMapping)"
                />
              </d-tab>
            </d-tabs>
          </d-card>
        </d-col>
      </d-row>
      <d-form-row class="mt-4">
        <d-button class="btn-primary" type="submit" :disabled="loading">Salvar</d-button>
      </d-form-row>
    </d-form>
    <confirmation-modal
      :cancel="closeModal"
      :confirm="handleConfirmation"
      :title="modalConfig.title"
      :message="modalConfig.message"
    />
  </d-container>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import SettingsService from '_services/rest/modules/settings';
import PdfService from '_services/rest/modules/pdf';
import mixin from '_common/mixins/ValidateForm';
import formatErrors from '_common/mixins/FormatErrors';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import { _LOAD_MODEL_PDF_TEMPLATES_, PDF_TEMPLATES, ROW_TABLE_TEMPLATE } from './SettingsModel';
import PdfMapper from './PdfMapper.vue';

export default {
  name: 'pdf-templates-form',
  mixins: [mixin, formatErrors],
  components: {
    ConfirmationModal,
    PdfMapper,
  },
  data() {
    return {
      activeTab: 0,
      loading: false,
      testingPdf: false,
      model: [],
      modalConfig: {
        title: '',
        message: '',
        type: '',
        tIndex: null,
        tableIdx: null,
      },
      errors: {},
    };
  },
  methods: {
    ...mapActions(['activeAlert', 'getSettings', 'setToggle']),
    uploadTestPdf(event, tIndex) {
      const file = event.target.files[0];
      if (!file) return;

      this.testingPdf = true;

      const params = {
        file,
        template: 'sample_memory_heat',
      };

      PdfService.extract(params)
        .then(response => {
          this.$set(this.model[tIndex], 'pdf_test_data', response.data ? response.data : response);

          if (!this.model[tIndex].mapping) {
            this.$set(this.model[tIndex], 'mapping', {});
          }

          this.activeAlert({ message: 'PDF processado com sucesso! Realize o mapeamento abaixo.', theme: 'success' });
        })
        .catch(err => {
          console.error('Erro na extração do PDF:', err);
          this.showError(err);
        })
        .finally(() => {
          this.testingPdf = false;
          event.target.value = '';
        });
    },
    getRiskTypeFromTemplate(typeStr) {
      if (!typeStr) return 'HEAT';
      const str = typeStr.toLowerCase();
      if (str.includes('noise')) return 'NOISE';
      if (str.includes('vibration')) return 'VIBRATION';
      if (str.includes('chemical')) return 'CHEMICAL';
      return 'HEAT';
    },
    addTemplate() {
      const newTemplate = { ...PDF_TEMPLATES, mapping: {} };
      this.model.push(newTemplate);
      this.updateTabs();
    },
    confirmRemoveTemplate(tIndex) {
      this.modalConfig = {
        title: 'Confirme exclusão do Modelo', message: 'Tem certeza que deseja excluir?', type: 'template', tIndex,
      };
      this.setToggle({ type: 'confirm_modal', bool: true });
    },
    confirmRemoveTable(tIndex, tableIdx) {
      this.modalConfig = {
        title: 'Confirme exclusão da Tabela', message: 'Deseja remover a Tabela?', type: 'table', tIndex, tableIdx,
      };
      this.setToggle({ type: 'confirm_modal', bool: true });
    },
    handleConfirmation() {
      const { type, tIndex, tableIdx } = this.modalConfig;

      if (type === 'template') {
        this.model.splice(tIndex, 1);
        this.updateTabs(0);
      } else if (type === 'table') {
        this.model[tIndex].tables.splice(tableIdx, 1);
      }

      this.closeModal();
    },
    closeModal() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    formatTypeKey(index) {
      const val = this.model[index].type;
      this.model[index].type = val.toLowerCase().replace(/[^a-z0-9_]/g, '_');
    },
    updateTabs(targetIndex = null) {
      setTimeout(() => {
        if (this.$refs.tabs) {
          this.$refs.tabs.updateTabs();
          this.activeTab = targetIndex !== null ? targetIndex : (this.model.length - 1);
        }
      }, 50);
    },
    addTable(tIdx) {
      this.model[tIdx].tables.push({ ...ROW_TABLE_TEMPLATE });
    },
    removeTable(tIdx, tableIdx) {
      this.model[tIdx].tables.splice(tableIdx, 1);
    },
    addHeader(event, tIdx, tableIdx) {
      const val = event.target.value.trim();
      if (val) {
        const headers = this.model[tIdx].tables[tableIdx].headers || [];
        headers.push(val);
        this.$set(this.model[tIdx].tables[tableIdx], 'headers', headers);
        event.target.value = '';
      }
    },
    addIgnore(event, tIdx, tableIdx) {
      const val = event.target.value.trim();
      if (val) {
        const ignore = this.model[tIdx].tables[tableIdx].ignore || [];
        ignore.push(val);
        this.$set(this.model[tIdx].tables[tableIdx], 'ignore', ignore);
        event.target.value = '';
      }
    },
    checkFields() {
      this.errors = {};

      this.model.forEach((template, index) => {
        this.$set(this.errors, `${index}.type`, { required: true });
      });

      Object.keys(this.errors).forEach(field => {
        Object.keys(this.errors[field]).forEach(validation => { this.callValidationFunctions(field, validation); });
      });
    },
    save() {
      this.checkFields();
      if (this.checkForm()) {
        this.loading = true;

        const payload = { templates: this.model };

        SettingsService.saveOptions(payload, 'pdf')
          .then(() => {
            this.getSettings();
            this.activeAlert({ message: 'Configurações e Mapeamento salvos com sucesso!', theme: 'success' });
          })
          .catch(err => this.showError(err))
          .finally(() => { this.loading = false; });
      }
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_PDF_TEMPLATES_, newValue => {
      if (newValue) {
        const data = newValue.templates ? newValue.templates : newValue;
        const dataArray = Array.isArray(data) ? [...data] : Object.values(data);

        this.model = dataArray.map(template => ({ ...template, mapping: template.mapping || {} }));
        this.updateTabs(0);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.table-title { font-weight: bold; color: #424242; }

.min-h-tags { min-height: 48px; }

.options {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  padding-left: 0;

  li {
    padding: 4px 8px;
    border: 1px dashed #ff6d00;
    border-radius: 4px;
    margin-right: 6px;
    margin-bottom: 6px;
    background: #fff3e0;
    color: #ff6d00;
    font-size: 12px;
    display: flex;
    align-items: center;
    transition: all 0.2s;

    &:hover { background: #ff6d00; color: #fff; }

    .delete { cursor: pointer; margin-right: 5px; display: flex; align-items: center; }
  }

  .bg-grey-tag {
    background: #eceff1;
    border-color: #90a4ae;
    color: #455a64;
    &:hover { background: #455a64; color: #fff; }
  }

  .add-new-tag {
    background: transparent;
    border: 1px dashed #ced4da;
    padding: 0;
    &:hover { background: transparent; }

    input {
      border: none;
      background: transparent;
      padding: 4px 8px;
      font-size: 12px;
      outline: none;
      width: 140px;
      color: #495057;
    }
  }
}

.fas {
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  &.fa-plus:hover{
    color: $green;
  }
  &.fa-minus:hover{
    color: $red
  }
  &.fa-save:hover{
    color: $blue;
  }
}
</style>
